export type StoreReviewRow = {
  id: string;
  branch_id: string;
  customer_id: string | null;
  score: number;
  comment: string | null;
  merchant_reply: string | null;
  merchant_replied_at: string | null;
  merchant_replied_by: string | null;
  order_id: string | null;
  appointment_id: string | null;
  created_at: string;
};

export type StoreReviewFilter = 'all' | 'unanswered' | 'low';

export type StoreReviewStats = {
  total: number;
  unanswered: number;
  low: number;
  avg_score: number;
};

export const STORE_REVIEW_REPLY_MAX = 500;

/** Tamaño de página para paginación del inbox. */
export const STORE_REVIEWS_PAGE_SIZE = 50;
